module.exports = {"210224100":"大长山岛镇","210224101":"獐子岛镇","210224102":"广鹿岛镇","210224201":"小长山乡","210224203":"海洋乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210224.json
// module id = 473
// module chunks = 0